import _ from "lodash";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { GET_AuthFunction } from "../services/Auth";
import { GET_RolePermissionsByUser } from "../services/Role";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken, removeToken } from "../utils/token";

const MOBILE_WIDTH = process.env.REACT_APP_MOBILE_WIDTH || 768;

function* CHANGE_WindowScreenSize({ payload }) {
  const isMobile = yield select((state) => state.Global.isMobile);

  if (payload <= MOBILE_WIDTH && isMobile !== true)
    yield put({ type: "SAVE_isMobile", payload: true });

  if (payload > MOBILE_WIDTH && isMobile !== false)
    yield put({ type: "SAVE_isMobile", payload: false });
}

function* INITIAL({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);

    yield put({ type: "SAVE_isReady", payload: false });

    if (token !== "" && !_.isNull(token) && !_.isUndefined(token)) {
      // 從 access_token 解析用戶資訊
      try {
        const { jwtDecode: decodeJwt } = require("jwt-decode");
        const tokenPayload = decodeJwt(token);
        yield put({ type: "SAVE_UserInfo", payload: tokenPayload });
      } catch (e) { /* token 格式不對就跳過 */ }

      const data = yield call(jwtEncode, payload);
      const query = { Data: data };
      const res = yield call(GET_AuthFunction, token, query);
      const resData = yield call(jwtDecode, res.data);
      yield put({ type: "SAVE_AuthFunction", payload: resData.data });

      const res2 = yield call(GET_RolePermissionsByUser, token);
      const resData2 = yield call(jwtDecode, res2.data);
      yield put({ type: "SAVE_RolePermissionsByUser", payload: resData2.data });
    }

    yield put({ type: "SAVE_isReady", payload: true });

    if (callback) callback(false);
  } catch (error) {
    yield call(exception, error);
    yield call(removeToken);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("CHANGE_WindowScreenSize", CHANGE_WindowScreenSize);
  yield takeLatest("INITIAL", INITIAL);
}
